<template>
    <div>
    <div @click="asdji">
        <i class="el-icon-back"></i>
        <span class="zi">返回</span>
        <el-divider direction="vertical"></el-divider>
        <span class="zi">设置禁用规则</span>
    </div>
        <div class="tip">
            <div class="table">
               <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent>
                    <div class="tr du">
                        <div class="dsu">删除时间:</div>
                        <el-form-item prop="radio">
                        <div class="asdas">
                            <el-radio-group v-model="form.radio" :disabled="disabled" @change="getTime">
                                <el-radio :label="1">当日</el-radio>
                                <el-radio :label="2">近三天</el-radio>
                                <el-radio :label="3">近7天</el-radio>
                            </el-radio-group>
                        </div>
                        </el-form-item>
                    </div>
                    <el-form-item prop="number">
                    <div class="tr du">
                        <div class="dsu">删除客户数量:</div>
                            <div class="asdas">
                                <el-input
                                type="number"
                                placeholder="请输入数字"
                                v-model="form.number"
                                :disabled="disabled"
                                clearable>
                                <template slot="append">人</template>
                                </el-input>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                    <div class="tr du" style="margin-top: -10px;">
                        <div class="dsu">
                        <div class="dsu">
                            <el-tooltip content="白名单内成员不会按此规则被禁用" placement="top-start">
                                <img class="ding02" src="../../assets/images/question.png"/>
                            </el-tooltip>
                            白名单:
                            </div>
                            </div>
                            <div class="asdas">
                                <button :class="disabled === true ? 'wqeyu' : 'wqeyu01'" :disabled="disabled" @click="getData">选择</button>
                                <div class="qwedsdd" v-if="disabled === true" style="margin-left: 0;">
                                    <el-tag
                                    v-for="tag in sendName"
                                    :key="tag.user"
                                    :type="tag.type"
                                    effect="plain">
                                    <img class="imsdsg" src="../../assets/images/user.png" width="14px" height="14px;"/>
                                    {{tag.name}}
                                    </el-tag>
                                </div>
                                <div class="qwedsdd" v-else style="margin-left: 0;">
                                    <el-tag
                                    v-for="tag in sendName"
                                    :key="tag.user"
                                    :disabled="disabled"
                                    :type="tag.type"
                                    effect="plain">
                                    <img class="imsdsg" src="../../assets/images/user.png" width="14px" height="14px;"/>
                                    {{tag.name}}
                                    </el-tag>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                 <!--<el-form-item prop="text">
                   <div style="    display: flex;
    margin-left: 36px;
    margin-top: 34px;">
                     <div class="dsu">通知人: </div>
                   </div>
                   <div style="display: flex;
    margin-left: 80px;">

                     <div class="dsu">通知人: </div>
                     <div class="dsu" style="margin-left: 90px">固定通知人</div>
                     <div style="font-size: 12px;
    margin-left: 32px;color:  #808080">请在“系统设置”中为固定通知人添加“删除提醒”的权限</div>
                   </div>
                   <div style="display: flex;
    margin-left: 170px;margin-top: 24px">
                     <div class="dsu">直属上级</div>
                     <div class="asdas" style="margin-left: 62px">
                       <el-radio-group v-model="form2.radio" :disabled="disabled" @change="handleRadioChange">
                         <el-radio :label="1">直属上级</el-radio>
                         <el-radio :label="2">自定义字段</el-radio>
                       </el-radio-group>
                     </div>
                     <div class="asdas"  v-if="showInput"  >
                       <el-input
                         style="margin-left: 15px"
                         type="text"
                         placeholder="请输字段名称，如直属上级"
                         v-model="form2.text"
                         :disabled="disabled"
                         clearable>
                       </el-input>
                     </div>
                   </div>
                   <div class="tr du"></div>
                 </el-form-item>-->
                 <el-form-item prop="text">

                    <div  style="display: flex;   margin:30px 30px 30px 30px;">
                      <el-radio-group  v-model="tipsRadio" @change="tipsRadioChange">
                        <el-radio-button label="固定通知人"></el-radio-button>
                        <el-radio-button class="ty-radio-button200" label="自定义通知人"></el-radio-button>
                      </el-radio-group>
                    </div>
                    <div style="overflow: hidden;" v-if="tipsRadio=='固定通知人'">
                      <div style="display: flex; margin-left: 40px;">
                        <div class="dsu" >通知人：
                        <el-tooltip content='在 "系统管理" 中添加 "删除提醒" 的权限的员工' placement="top-start">
                          <img class="ding02" src="../../assets/images/question.png"/>
                        </el-tooltip>
                        </div>
                        <div style="font-size: 12px; color:  #808080;width: 85%;">
                          <div class="tr du" style="margin-top: -30px;border: none">
                            <div class="asdas">
                              <!-- <button :class="disabled === true ? 'wqeyu' : 'wqeyu01'" :disabled="disabled" @click="showStaffDialog">选择</button> -->
                              <div class="qwedsdd" v-if="disabled === true" style="margin-left: 0;">
                                  <el-tag v-for="tag in noticeStaff" :key="tag.user" :type="tag.type" effect="plain">
                                    <img class="imsdsg" src="../../assets/images/user.png" width="14px" height="14px;"/>
                                    {{tag.name}}
                                  </el-tag>
                              </div>
                              <div class="qwedsdd" v-else style="margin-left: 0;">
                                  <el-tag v-for="tag in noticeStaff" :key="tag.user" :disabled="disabled" :type="tag.type" effect="plain">
                                    <img class="imsdsg" src="../../assets/images/user.png" width="14px" height="14px;"/>
                                    {{tag.name}}
                                  </el-tag>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="display: flex; margin-left: 40px;">
                        <div class="dsu" >通知方式：</div>
                        <div style=" color:  #808080; ">
                          <div class="tr du" style="margin-top: -30px; border: none;">
                            <div class="asdas">
                              <div style="overflow: hidden;margin-bottom: 20px;">
                                <span style="padding: 20px;">应用通知
                                <el-tooltip content='"通知人" 可在企业微信的 "应用通知" 中收到提醒' placement="top-start">
                                  <img class="ding02" src="../../assets/images/question.png"/>
                                </el-tooltip>
                                </span>
                                <!--<el-switch v-model="form.fix_app_notice" :active-value="1" :inactive-value="2" disabled="true" active-color="#204A9E"></el-switch>-->
                              </div>
                              <div  style="overflow: hidden;">
                                <span style="padding: 20px;">邮件通知
                                <el-tooltip content='填写后，该邮箱会收到删除通知的提醒' placement="top-start">
                                  <img class="ding02" src="../../assets/images/question.png"/>
                                </el-tooltip>
                                </span>
                                <el-input style="width: 300px;" v-model="form.fix_mailbox" placeholder="请输入邮箱" :disabled="disabled"  clearable></el-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="overflow: hidden;" v-if="tipsRadio=='自定义通知人'">

                      <div style=" margin-left: 40px; overflow: hidden; margin-bottom: 30px;">
                        <div  style="  float: left;">
                          <span>应用通知：</span>
                          <el-tooltip content='开启后，“通知人” 可在企业微信的 “应用通知” 中收到提醒' placement="top-start">
                            <img class="ding02" src="../../assets/images/question.png"/>
                          </el-tooltip>
                        </div>
                        <div style=" color:  #808080; float: left; width: 80%; ">
                          <div  style=" border: none; overflow: hidden; width: 80%; padding-left: 27px;">
                            <div style=" overflow: hidden; height: 60px; width: 80%;  text-align: left;">
                               <el-switch v-model="form.free_app_notice" :disabled="disabled" :active-value="1" :inactive-value="2" active-color="#204A9E" ></el-switch>
                            </div>

                            <div  style="overflow: hidden; text-align: left;">
                              <span >存档员工的</span>
                              <span style="padding:0px 10px;">
                                <el-select v-model="form.leader_option1" :disabled="disabled"  class="type-select" style="width: 120px;">
                                  <el-option v-for="(item, index) in leaderOptions[1]" :key="index" :label="item.label" :value="item.value" > </el-option>
                                </el-select>
                              </span>
                              <span style="">字段，去匹配上级员工的</span>
                              <span style="padding:0px 10px;">
                                <el-select v-model="form.staff_option1" :disabled="disabled"  class="type-select" style="width: 120px;">
                                  <el-option v-for="(item, index) in staffOptions[1]" :key="index" :label="item.label" :value="item.value" > </el-option>
                                </el-select>
                              </span>
                              <span style="">字段，用于搭建企业微信中员工的上下级关系，最终将通知发送给上级</span>
                            </div>

                          </div>
                        </div>
                      </div>

                     <div style=" margin-left: 40px; overflow: hidden;">
                       <div  style=" float: left;">
                        <span>邮件通知：</span>
                        <el-tooltip content='开启后，“通知人”可在邮箱中收到提醒' placement="top-start">
                            <img class="ding02" src="../../assets/images/question.png"/>
                        </el-tooltip>
                        </div>
                       <div style=" color:  #808080; float: left; width: 80%;">
                         <div  style=" border: none; overflow: hidden; width: 100%; padding-left: 27px;">
                           <div style="overflow: hidden; margin-bottom: 20px;">
                             <div style="overflow: hidden;float: left; line-height: 36px;">
                                <el-switch v-model="form.free_mail_notice" :disabled="disabled" :active-value="1"  :inactive-value="2" active-color="#204A9E"  > </el-switch>
                              </div>

                            </div>

                            <div  style="overflow: hidden; text-align: left;">
                               <span >存档员工的在企业微信中的</span>
                               <span style="padding:0px 10px;">
                                 <el-select v-model="form.leader_option2" :disabled="disabled"  class="type-select" style="width: 120px;">
                                   <el-option v-for="(item, index) in leaderOptions[2]" :key="index" :label="item.label" :value="item.value" > </el-option>
                                 </el-select>
                               </span>
                               <span style="">字段，去匹配AD中的</span>
                               <span style="padding:0px 10px;">
                                 <el-select v-model="form.staff_option2" :disabled="disabled"  class="type-select" >
                                   <el-option v-for="(item, index) in staffOptions[2]" :key="index" :label="item.label" :value="item.value" > </el-option>
                                 </el-select>
                               </span>
                               <span style="">字段，用户完成企业微信与AD账号匹配，上下级关系搭建完成后，最终将通知发送到上级邮箱</span>
                             </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="tr du"></div>
                  </el-form-item>
                </el-form>
                <!--<div class="tr du" style="margin-top: 24px;">
                    <div class="dsu">
                    白名单
                    <el-tooltip content="白名单内成员不会按此规则被禁用" placement="top-start">
                        <img class="ding01" src="../../assets/images/question.png"/>
                    </el-tooltip>
                    </div>
                </div> -->
            </div>
            <div class="njhu">
                <el-button style="width: 72px;" v-if="show === true" type="primary" @click="redact">编辑</el-button>
                <el-button type="info" plain style="width: 72px;" v-if="show === false" @click="redact02">取消</el-button>
                <el-button style="width: 72px;" v-if="show === false" type="primary" @click="redact01('form')">保存</el-button>
            </div>
        </div>
        <department :isShow="isDepartmentDialog"  @check-user="checkUser"  :isMultiple="false"  v-if="isDepartmentDialog"  :checkeds="checkedEmployees"  ></department>
        <department :isShow="isStaffDialog"  @check-user="checkStaff"  :isMultiple="false"  v-if="isStaffDialog"  :checkeds="checkedStaffs"  ></department>
    </div>
</template>
<script>
import { regulation } from './regulation.js'
  export default { mixins: [regulation] }
</script>
<style lang="scss" scoped>
  @import "./regulation.scss";
</style>
